import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faKey } from '@fortawesome/free-solid-svg-icons'
import '../../../../../styles/balanco.scss'

const User = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchUsers()
    }
    const senha = async (id) => {
        props.senha(id)
    }
    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <tr>
                <td data-label="Usuário">{props.user.nome}</td>
                <td data-label="Nível">{props.user.nivel}</td>
                <td data-label="E-mail">{props.user.email}</td>
                {/* ---- CÉLULAS PARA DESKTOP (cada ação tem seu td) ---- */}
                <td className="acoes-desktop-cell" title="Editar" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="mx-2 text-warning cursor-pointer"
                        onClick={() => editar(props.user._id)}
                    />
                </td>

                <td className="acoes-desktop-cell" title="Trocar Senha" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faKey}
                        className="mx-2 text-warning cursor-pointer"
                        onClick={() => senha(props.user._id)}
                    />
                </td>

                <td className="acoes-desktop-cell" title="Excluir" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faTrash}
                        className="mx-2 text-danger cursor-pointer"
                        onClick={() => deletar(props.user._id)}
                    />
                </td>

                {/* ---- CÉLULA EXTRA: GRID DE AÇÕES APENAS PARA MOBILE ----
                     Esta célula fica no DOM sempre, mas será escondida no desktop.
                     No mobile mostramos ela e escondemos as acoes-desktop-cell. */}
                <td className="acoes-mobile-cell">
                    <div className="acoes-mobile">
                        <div className="acao-item" onClick={() => editar(props.user._id)}>
                            <FontAwesomeIcon icon={faPenToSquare} className="acao-icon text-warning" />
                            <span>Editar</span>
                        </div>

                        <div className="acao-item" onClick={() => senha(props.user._id)}>
                            <FontAwesomeIcon icon={faKey} className="acao-icon text-warning" />
                            <span>Senha</span>
                        </div>

                        <div className="acao-item" onClick={() => deletar(props.user._id)}>
                            <FontAwesomeIcon icon={faTrash} className="acao-icon text-danger" />
                            <span>Excluir</span>
                        </div>
                    </div>
                </td>
            </tr>
        </Fragment >)
}

export default User;